import { createCookie, eraseCookie } from 'utils/cookies';

import Constants from 'utils/Constants';
import { createSlice } from '@reduxjs/toolkit';

const initialState = () => {
  return {
    hasFetched: false,
    isFetching: false,
    isLogin: false,
    user: {},
  };
};

const publicUserReducer = createSlice({
  name: 'publicUser',
  initialState,
  reducers: {
    resetApp: () => {
      eraseCookie(Constants.PUBLIC_USER_ACCESS_TOKEN);
      return initialState();
    },
    setPublicUserLogin: (state, action) => {
      state.isLogin = true;
      createCookie(
        Constants.PUBLIC_USER_ACCESS_TOKEN,
        action.payload.accessToken,
        1,
      );
      state.user = action.payload.user;
      return state;
    },
    logoutPublicUser: (state) => {
      eraseCookie(Constants.PUBLIC_USER_ACCESS_TOKEN);
      return initialState();
    },
  },
});
export const { resetApp, setPublicUserLogin, logoutPublicUser } =
  publicUserReducer.actions;
export default publicUserReducer.reducer;
